import { getVisitorId, trackHeapEvent } from '@ratehub/base-ui';

import CreditCardShape from '../definitions/CreditCardShape';


/**
 * 'CC Web Click'-specific call to `trackHeapEvent`.
 * @param {CreditCardShape} cardInfo - the credit card
 * @param {string} cardInfo.detailsURL - URL for details
 * @param {string} cardInfo.bank - the provider
 * @param {boolean} cardInfo.isMonetized - is the card monetized?
 * @param {boolean} cardInfo.isSponsored - is the card sponsored?
 * @param {boolean} [trackHotJarSurvey=false] - Whether to trigger a HotJar survey event.
 */
function trackHeapEventCCWebClick({ detailsURL, bank, isMonetized, isSponsored }, trackHotJarSurvey = false) {
    trackHeapEvent('CC Web Click', {
        href: detailsURL,
        provider: bank,
        monetized: isMonetized.toString(),
        sponsored: isSponsored.toString(),
    });

    if (trackHotJarSurvey) {
        if (typeof window?.hj === 'undefined') {
            return;
        }

        const visitorId = getVisitorId();

        window.hj('event', 'cc_web_click', {
            href: detailsURL,
            provider: bank,
            monetized: isMonetized.toString(),
            sponsored: isSponsored.toString(),
            visitorId,
        });
    }
}

export default trackHeapEventCCWebClick;
